import React, { useEffect } from 'react';
import { DashlineSeparator, HeadlineContainer, StepText, buttonStyle } from '../../../components/common/CommonStyle';
import Button from '../../../atoms/buttons/Button';
import { successTextStyle } from './ChangeEmailStyle';
import EmailCaption from './EmailCaption';
import useMixPanel from '../../../hooks/useMixPanel';

const ChangeNewEmailSuccess = ({ email, redirectTo }) => {
  const { trackPageView } = useMixPanel();

  useEffect(() => {
    trackPageView('change-email-success');
  }, []);

  return (
    <>
      <HeadlineContainer>
        <StepText style={successTextStyle}>Success!</StepText>
        <EmailCaption label={`You’ve successfully changed your email to:`} email={email} />
        <DashlineSeparator />
        <Button
          customStyle={{ ...buttonStyle, margin: '20px 0px' }}
          buttonType="primaryRed"
          type="button"
          name="browseProfile"
          to={redirectTo}
        >
          Back to Browse Profiles
        </Button>
      </HeadlineContainer>
    </>
  );
};

export default ChangeNewEmailSuccess;
